import AppShell from "@/components/AppShell/AppShell"
import DeckBrowser from "@/components/DeckBrowser/DeckBrowser"
import DeckPreviewGate from "@/components/DeckPreviewGate/DeckPreviewGate"

/**
 * The deck on its own route, public: reachable with no sign-in and no session.
 * Same layout as `/deck`, minus the nav pill — its menus are facilitator-only
 * destinations with nowhere for a guest to open them to.
 *
 * `DeckPreviewGate` puts a password screen in front of the deck. It is a soft
 * deterrent only, not access control — see the component for why.
 */
export default function DeckPreviewPage() {
  return (
    <AppShell hideNav>
      <DeckPreviewGate>
        <DeckBrowser />
      </DeckPreviewGate>
    </AppShell>
  )
}
